import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    _createVNode("path", {
      "stroke-linecap": "round",
      d: "M13.507 4.908a7.25 7.25 0 013.88 2.24M18.895 9.76a7.25 7.25 0 010 4.48M17.388 16.851a7.25 7.25 0 01-3.88 2.24M10.493 19.092a7.25 7.25 0 01-3.88-2.24M5.105 14.24a7.25 7.25 0 010-4.48M6.612 7.149a7.25 7.25 0 013.88-2.24"
    })
  ]))
}